import React from 'react'
import { Button } from 'vnetwork-ui'
import { useForm } from 'react-hook-form'
import { DayOffBODApprove } from '@/modules/Dayoffs/types/payload'
import { approveBodDayOff } from '@/modules/Dayoffs/services'
import toast from 'react-hot-toast'
import { IPermissionProps } from '@/types/shared'
import { FormItem } from 'vnetwork-ui'
import { useTranslation } from 'react-i18next'
import { useRefetchDayOffQueries } from '@/modules/Dayoffs/constants'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
interface DayOffFormBODApproveAllProps extends IPermissionProps {
    ids: number[]
    onClose?: () => void
    refetch: () => void
}
const BODFormApproveAll: React.FC<DayOffFormBODApproveAllProps> = ({
    ids,
    onClose,
    refetch,
}) => {
    const { t: translate } = useTranslation('dayoffs')
    const { refetchAll } = useRefetchDayOffQueries()
    const { mutateAsync: BODConfirm, isPending: isBODConfirming } =
        useMutationWithHandler(
            {
                mutationFn: approveBodDayOff,
            },
            {
                reactQueryKeys: QUERY_KEYS.DAYOFFS,
                errorMessage: translate('something_went_wrong'),
            }
        )

    const { control: controlBodForm, handleSubmit: handleBodConfirm } =
        useForm<DayOffBODApprove>({
            defaultValues: {
                day_off_feedback_bod: translate('approved'),
            },
        })

    const onBodSubmit = async (dataReq: DayOffBODApprove) => {
        if (dataReq?.day_off_feedback_bod?.trim() === '') {
            toast.error(translate('please_feedback'))
            return
        }
        try {
            const promises = ids.map((id) =>
                BODConfirm({
                    id: id || 0,
                    feedback: {
                        day_off_feedback_bod: dataReq?.day_off_feedback_bod,
                    },
                })
            )
            await Promise.all(promises)
            toast.success(translate('bulk_approve_success'))
            if (onClose) onClose()
            refetch()
            refetchAll()
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="w-full bg-white rounded-lg border border-gray-200 p-4 text-sm h-full">
            <form
                onSubmit={handleBodConfirm(onBodSubmit)}
                className="flex flex-col h-full"
            >
                <FormItem
                    control={controlBodForm}
                    name="day_off_feedback_bod"
                    type="textarea"
                    placeholder={translate('bod_feedback_placeholder')}
                    label={translate('feedback')}
                    disabled={isBODConfirming || ids.length === 0}
                />
                <div className="w-full flex justify-end gap-2 mt-auto pt-2">
                    {onClose && (
                        <Button
                            size="small"
                            type="button"
                            onClick={onClose}
                            variant="outlined"
                        >
                            {translate('close')}
                        </Button>
                    )}
                    <Button
                        loading={isBODConfirming}
                        type="submit"
                        size="small"
                        disabled={isBODConfirming || ids.length === 0}
                    >
                        {translate('confirm')}{' '}
                        {ids.length > 0 && `(${ids.length})`}
                    </Button>
                </div>
            </form>
        </div>
    )
}
export const BODApproveAllForm = (props: DayOffFormBODApproveAllProps) => {
    return <BODFormApproveAll {...props} />
}
